import type { Activity } from '../types/activity'

export const contact = {
  name: 'Connor Festag',
  initials: 'CF',
  role: 'Borrower',
  loanId: 'LN-40912',
  stage: 'Docs Out',
  phone: '(480) 555-0147',
  email: 'c.festag@outlook.com',
  owner: 'Dana Whitfield',
}

export const activities: Activity[] = [
  {
    id: 'a-01',
    channel: 'event',
    direction: 'system',
    title: 'Added to Five9 list: Ghost List',
    at: '2026-09-14T14:10:00',
    outcome: 'completed',
    summary: 'Auto-added after 6 outbound attempts with no connect in 5 days.',
    actor: 'Five9 automation',
    note: 'Dialer will pause outbound attempts for 48 hours. Next eligible attempt: Sep 16, 9:00 AM.',
    details: [
      { label: 'Source', value: 'Five9 dialer' },
      { label: 'Rule', value: '6 attempts / 5 days, no connect' },
      { label: 'Loan', value: 'LN-40912 · Docs Out' },
    ],
  },
  {
    id: 'a-02',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — no answer',
    at: '2026-09-14T13:47:00',
    durationSeconds: 8,
    outcome: 'no-answer',
    summary: 'Rang out, no voicemail left.',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 08s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-03',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — no answer',
    at: '2026-09-14T13:44:00',
    durationSeconds: 5,
    outcome: 'no-answer',
    summary: 'Rang out, no voicemail left.',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 05s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-04',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — voicemail left',
    at: '2026-09-14T13:41:00',
    durationSeconds: 32,
    outcome: 'voicemail',
    summary: 'Left callback request referencing the updated rate lock.',
    actor: 'Dana Whitfield',
    note: 'Asked him to call back today — lock expires Friday and we still need the 2025 W-2.',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 32s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-05',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-14T11:02:00',
    outcome: 'sent',
    summary: '“Connor, good news. I think you’ll like what I’ve put together…”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 14, 2026 at 11:02 AM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-05-1',
        from: 'you',
        body: 'Connor, good news. I think you’ll like what I’ve put together for you, but I need you to call me back right away please.',
        at: '2026-09-14T11:02:00',
      },
    ],
  },
  {
    id: 'a-06',
    channel: 'call',
    direction: 'outbound',
    title: 'Call connected — income docs confirmed',
    at: '2026-09-13T16:20:00',
    durationSeconds: 168,
    outcome: 'connected',
    summary: 'Confirmed he will send the 2025 W-2 and two recent pay stubs.',
    actor: 'Dana Whitfield',
    note: 'Connor is travelling for work until Tuesday and prefers texts during the day. He asked whether the 5.875% quote holds if closing slips a week — told him we would confirm with underwriting.',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '2m 48s' },
      { label: 'Agent', value: 'Dana Whitfield' },
      { label: 'Disposition', value: 'Connected · follow-up scheduled' },
    ],
  },
  {
    id: 'a-07',
    channel: 'email',
    direction: 'outbound',
    title: 'Submission form completed — Festag, Connor',
    at: '2026-09-13T10:05:00',
    outcome: 'sent',
    summary: 'Automated confirmation with the submission packet attached',
    actor: 'Loan Origination System',
    note: 'Automated confirmation with the completed submission packet attached (4 pages).',
    details: [
      { label: 'Sent', value: 'Sep 13, 2026 at 10:05 AM' },
      { label: 'To', value: 'c.festag@outlook.com' },
      { label: 'From', value: 'docs@northbridgelending.com' },
      { label: 'Sent by', value: 'Loan Origination System' },
    ],
  },
  {
    id: 'a-08',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-12T15:30:00',
    outcome: 'sent',
    summary: '“I understand you’re in the middle of work, no problem…”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 12, 2026 at 3:30 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-08-1',
        from: 'you',
        body: 'I understand you’re in the middle of work, no problem. What time works this evening for a 10-minute call?',
        at: '2026-09-12T15:30:00',
      },
    ],
  },
  {
    id: 'a-08b',
    channel: 'sms',
    direction: 'inbound',
    title: 'Text received',
    at: '2026-09-12T15:46:00',
    outcome: 'received',
    summary: '“After 7 is best. Sorry for the runaround.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Received', value: 'Sep 12, 2026 at 3:46 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-08-2',
        from: 'contact',
        body: 'After 7 is best. Sorry for the runaround.',
        at: '2026-09-12T15:46:00',
      },
    ],
  },
  {
    id: 'a-09',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — no answer',
    at: '2026-09-12T09:15:00',
    durationSeconds: 12,
    outcome: 'no-answer',
    summary: 'Rang out, no voicemail left.',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 12s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-10',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — no answer',
    at: '2026-09-12T09:12:00',
    durationSeconds: 6,
    outcome: 'no-answer',
    summary: 'Rang out, no voicemail left.',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 06s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-11',
    channel: 'event',
    direction: 'system',
    title: 'Loan status changed to Docs Out',
    at: '2026-09-11T17:00:00',
    outcome: 'completed',
    summary: 'Moved from Underwriting Review by Priya Raman.',
    actor: 'Priya Raman',
    note: 'Closing disclosure released to the borrower portal. Signature window opens Sep 15.',
    details: [
      { label: 'Previous stage', value: 'Underwriting Review' },
      { label: 'New stage', value: 'Docs Out' },
      { label: 'Changed by', value: 'Priya Raman' },
    ],
  },
  {
    id: 'a-12',
    channel: 'call',
    direction: 'inbound',
    title: 'Inbound call — rate question',
    at: '2026-09-10T12:01:00',
    durationSeconds: 428,
    outcome: 'connected',
    summary: 'Connor called in about the 5.875% lock and appraisal timing.',
    actor: 'Marcus Lee',
    note: 'Walked through the lock expiration and appraisal schedule. He asked for a written summary — Dana to follow up by email.',
    details: [
      { label: 'Direction', value: 'Inbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '7m 08s' },
      { label: 'Agent', value: 'Marcus Lee' },
      { label: 'Disposition', value: 'Connected · transferred to Dana' },
    ],
  },
  {
    id: 'a-13',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-09T14:30:00',
    outcome: 'sent',
    summary: '“Quick reminder on the W-2 — the upload link is still active…”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 9, 2026 at 2:30 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-13-1',
        from: 'you',
        body: 'Quick reminder on the W-2 — the upload link is still active and takes about two minutes.',
        at: '2026-09-09T14:30:00',
      },
    ],
  },
  {
    id: 'a-14',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — no answer',
    at: '2026-09-09T16:52:00',
    durationSeconds: 15,
    outcome: 'no-answer',
    summary: 'Rang out, no voicemail left.',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 15s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-15',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — no answer',
    at: '2026-09-09T16:48:00',
    durationSeconds: 5,
    outcome: 'no-answer',
    summary: 'Rang out, no voicemail left.',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 05s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-16',
    channel: 'call',
    direction: 'outbound',
    title: 'Outbound call — no answer',
    at: '2026-09-09T16:17:00',
    durationSeconds: 32,
    outcome: 'no-answer',
    summary: 'Rang out, no voicemail left.',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Direction', value: 'Outbound' },
      { label: 'Number', value: '(480) 555-0147 · mobile' },
      { label: 'Duration', value: '0m 32s' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-17',
    channel: 'email',
    direction: 'outbound',
    title: 'Rate lock confirmation — 5.875%',
    at: '2026-09-08T09:30:00',
    outcome: 'sent',
    summary: 'Lock agreement and remaining conditions checklist attached',
    actor: 'Dana Whitfield',
    note: 'Included the lock agreement PDF and the remaining conditions checklist.',
    details: [
      { label: 'Sent', value: 'Sep 8, 2026 at 9:30 AM' },
      { label: 'To', value: 'c.festag@outlook.com' },
      { label: 'From', value: 'dana.whitfield@northbridgelending.com' },
      { label: 'Attachments', value: 'Lock agreement (2 pages)' },
      { label: 'Sent by', value: 'Dana Whitfield' },
    ],
  },
  {
    id: 'a-18',
    channel: 'sms',
    direction: 'inbound',
    title: 'Text received',
    at: '2026-09-04T18:46:00',
    outcome: 'received',
    summary: '“Just submitted the form, let me know if anything is missing.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Received', value: 'Sep 4, 2026 at 6:46 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-18-1',
        from: 'contact',
        body: 'Just submitted the form, let me know if anything is missing.',
        at: '2026-09-04T18:46:00',
      },
    ],
  },
  {
    id: 'a-18b',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-04T19:02:00',
    outcome: 'sent',
    summary: '“Got it, thank you. I’ll review tonight and flag anything outstanding.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 4, 2026 at 7:02 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-18-2',
        from: 'you',
        body: 'Got it, thank you. I’ll review tonight and flag anything outstanding.',
        at: '2026-09-04T19:02:00',
      },
    ],
  },
  {
    id: 'a-18c',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-04T19:20:00',
    outcome: 'sent',
    summary: '“All good except the 2025 W-2 — I’ll send an upload link tomorrow.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 4, 2026 at 7:20 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-18-3',
        from: 'you',
        body: 'All good except the 2025 W-2 — I’ll send an upload link tomorrow.',
        at: '2026-09-04T19:20:00',
      },
    ],
  },
  {
    id: 'a-19',
    channel: 'event',
    direction: 'system',
    title: 'Submission form completed',
    at: '2026-09-04T18:44:00',
    outcome: 'completed',
    summary: 'Borrower completed the online application in 11 minutes.',
    actor: 'Borrower portal',
    note: 'Application submitted from mobile Safari. Credit pull authorized at submission.',
    details: [
      { label: 'Source', value: 'Borrower portal' },
      { label: 'Time to complete', value: '11m 04s' },
      { label: 'Consent', value: 'Credit pull authorized' },
    ],
  },
  {
    id: 'a-20',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-05T09:12:00',
    outcome: 'sent',
    summary: '“Here’s the secure upload link for the 2025 W-2.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 5, 2026 at 9:12 AM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-20-1',
        from: 'you',
        body: 'Here’s the secure upload link for the 2025 W-2: northbridge.co/u/40912. It expires in 14 days.',
        at: '2026-09-05T09:12:00',
      },
    ],
  },
  {
    id: 'a-21',
    channel: 'sms',
    direction: 'inbound',
    title: 'Text received',
    at: '2026-09-08T18:04:00',
    outcome: 'received',
    summary: '“Sorry, crazy week. Is the 5.875% still good?”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Received', value: 'Sep 8, 2026 at 6:04 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-21-1',
        from: 'contact',
        body: 'Sorry, crazy week. Is the 5.875% still good?',
        at: '2026-09-08T18:04:00',
      },
    ],
  },
  {
    id: 'a-21b',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-08T18:11:00',
    outcome: 'sent',
    summary: '“It is — locked through Sep 18. I emailed the lock agreement…”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 8, 2026 at 6:11 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-21-2',
        from: 'you',
        body: 'It is — locked through Sep 18. I emailed the lock agreement this morning so you have it in writing.',
        at: '2026-09-08T18:11:00',
      },
    ],
  },
  {
    id: 'a-21c',
    channel: 'sms',
    direction: 'inbound',
    title: 'Text received',
    at: '2026-09-08T18:13:00',
    outcome: 'received',
    summary: '“Perfect. I’ll get you the W-2 this weekend.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Received', value: 'Sep 8, 2026 at 6:13 PM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-21-3',
        from: 'contact',
        body: 'Perfect. I’ll get you the W-2 this weekend.',
        at: '2026-09-08T18:13:00',
      },
    ],
  },
  {
    id: 'a-22',
    channel: 'sms',
    direction: 'inbound',
    title: 'Text received',
    at: '2026-09-11T08:22:00',
    outcome: 'received',
    summary: '“Traveling for work through Tuesday — text is best.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Received', value: 'Sep 11, 2026 at 8:22 AM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-22-1',
        from: 'contact',
        body: 'Traveling for work through Tuesday — text is best. Didn’t get to the W-2 yet.',
        at: '2026-09-11T08:22:00',
      },
    ],
  },
  {
    id: 'a-22b',
    channel: 'sms',
    direction: 'outbound',
    title: 'Text sent',
    at: '2026-09-11T08:30:00',
    outcome: 'sent',
    summary: '“No problem. I’ll keep the link active and check back Wednesday.”',
    actor: 'Dana Whitfield',
    details: [
      { label: 'Sent', value: 'Sep 11, 2026 at 8:30 AM' },
      { label: 'Agent', value: 'Dana Whitfield' },
    ],
    messages: [
      {
        id: 'm-22-2',
        from: 'you',
        body: 'No problem. I’ll keep the link active and check back Wednesday.',
        at: '2026-09-11T08:30:00',
      },
    ],
  },
  {
    id: 'a-23',
    channel: 'email',
    direction: 'outbound',
    title: 'Conditions checklist — Festag, Connor',
    at: '2026-09-03T08:15:00',
    outcome: 'sent',
    summary: 'Outstanding conditions checklist for the file',
    actor: 'Dana Whitfield',
    note: 'Listed the four remaining conditions, with the 2025 W-2 flagged as the blocker.',
    details: [
      { label: 'Sent', value: 'Sep 3, 2026 at 8:15 AM' },
      { label: 'To', value: 'c.festag@outlook.com' },
      { label: 'From', value: 'dana.whitfield@northbridgelending.com' },
      { label: 'Sent by', value: 'Dana Whitfield' },
    ],
  },
]
